// modified from http://stackoverflow.com/a/34318158/2044922
import Mixpanel from 'mixpanel-browser'
import 'whatwg-fetch'
import { userToken } from 'helpers/auth'

function isApiRequest ({ api }) {
  return api && typeof api === 'function'
}

function parseAndValidate (response) {
  // my no-content responses have no content, so response.json() throws an error
  if (response.status === 204) {
    return {
      success: true
    }
  }

  return response.json().then(resp => {
    if (response.status >= 200 && response.status < 300) {
      return resp
    }

    let error = {
      name: resp.name || response.statusText,
      status: resp.status || response.status,
      message: resp.message
    }
    throw error
  })
}

function makeRequest (store, urlBase, { api, types, ...rest }, next) {
  const [ REQUEST, SUCCESS, FAILURE ] = types

  let nextAction = { ...rest, type: REQUEST }
  if (rest.onApiRequest && typeof rest.onApiRequest === 'function') {
    nextAction = rest.onApiRequest(nextAction)
  }

  next(nextAction)
  next({ type: 'API_REQUEST', associated: nextAction })

  const apiRequest = (url, params = {}, requireAuthentication = true) => {
    const token = userToken() // WARNING: This may not be valid
    const defaultParams = {
      credentials: 'same-origin',
      method: 'get',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'x-access-token': token
      }
    }

    params = Object.assign({}, defaultParams, params)
    params.headers = Object.assign({}, defaultParams.headers, params.headers)
    params.body = JSON.stringify(params.body)

    if (!requireAuthentication || !token) { // remove || !token if redircting to /login
      delete params.headers['x-access-token']
    } else if (requireAuthentication && !token) {
      // send a failure
      let nextAction = { ...rest,
        error: {
          status: 401,
          name: 'Unauthorized',
          message: 'You must login to continue.'
        },
        type: FAILURE
      }

      // Send an event to Mixpanel with this failure.
      Mixpanel.track('error:middleware/unauthorized', { type: FAILURE })

      let returnMe = next(nextAction)
      next({ type: 'API_FAILURE', associated: nextAction })

      return returnMe
    }

    return fetch(urlBase + url, params)
      .then(parseAndValidate)
      .then(payload => {
        let nextAction = { ...rest, payload, type: SUCCESS }
        if (rest.onApiSuccess && typeof rest.onApiSuccess === 'function') {
          nextAction = rest.onApiSuccess(nextAction, payload)
        }

        let returnMe = next(nextAction)
        next({ type: 'API_SUCCESS', associated: nextAction })

        return returnMe
      })
      .catch(error => {
        console.error(`Error @ middleware/api: ${FAILURE}`, error)
        let nextAction = { ...rest, error, type: FAILURE }
        if (rest.onApiFailure && typeof rest.onApiFailure === 'function') {
          nextAction = rest.onApiFailure(nextAction, error)
        }

        // Send an event to Mixpanel with this failure.
        Mixpanel.track('error:middleware/api', { ...error, type: FAILURE })

        let returnMe = next(nextAction)
        next({ type: 'API_FAILURE', associated: nextAction })

        return returnMe
      })
  }

  return api(apiRequest)
}

export default function apiMiddleware (urlBase) {
  return store => next => action => {
    if (isApiRequest(action)) {
      return makeRequest(store, urlBase, action, next)
    }

    return next(action)
  }
}



// WEBPACK FOOTER //
// ./src/middleware/api.js